// components/Topbar.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import logo from '../assets/images/logo-white.png';


function Topbar() {
  return (
    <Navbar expand="lg" className="topbar navbar-dark py-2">
      <Container className="d-flex">
        <Navbar.Brand as={Link} to="/" className="logo">
          <Image src={logo} alt="Excellenc3" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="nav" className="border-0 shadow-none" />
        <small className="flex-fill text-center py-2 py-lg-0">Welcome to Excellenc3 — your workspace for creating powerful business apps with AI guidance.</small>
        <Navbar.Collapse id="nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/apps">Apps</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Topbar;
